/**
 * @author Ariel
 * @date 2020-08-17
 * @desc 报名管理--报名记录管理--批量导入学员
 */
import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../../tool'
import {WizTableForm} from "../../../common";
import {ExportExcel} from '@/components/index'

let {WizContainer, modelUtils} = framework_tool
let {WizSpin,WizTypography,WizModal} = component_tool
let {Paragraph} = WizTypography;

class ApplyStudentImport extends WizContainer {
  componentName = 'applyStudentImport';

  constructor(props) {
    super(props);
    this.state = {
      planId: null
    }
    this.info = []
  }

  _applyStudentImportOnChange(nextProps, nextState) {
    let o = nextProps.applyStudentImport
    if (o['success']) {
      let data = o['data'];
      let str = data['import'].toString().replace(/<br\/>/g, "\n")
      let info =data['info']
      this.info = info;
      if (this.props.callback) {
        this.props.callback(this.info)
      }
      WizModal.success({
        title: '导入结果',
        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    applyStudentImport: this._applyStudentImportOnChange.bind(this)
  }

  getPlanItem(values) {
    let row = values.valueRows
    if (row && row[0]) {
      let data = row[0]
      this.setState({planId: data.id})
    }
  }

  _render() {
    let applyId = this.props.applyId;
    let planIds = this.props.planIds;

    let planList = WizTableForm.Config.plan(this, {apiParams: {ids: planIds.split(',')}})

    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '批量导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_applyStudent
      }
    }

    let submit = (file, fileData, other) => {
      const {planId} = this.state
      if(!planId) {
        wizNotice.error("请选择计划安排")
        return false;
      } else {
        this.doAction({
          path: 'apply/importApplyStudent',
          payload: {
            key: 'importApplyStudent',
            apiParams: {
              applyId: applyId,
              planId: planId,
              fileData: fileData
            }
          }
        })
      }
    }

    let other = [
      {
        item: {label: '所属计划安排: ', required: true},
        comp: (callback) => {
          return (
            <WizTableForm
              selectType={'radio'}
              {...planList}
              onChangeRowMap={this.getPlanItem.bind(this)}
              onSubmit={this.getPlanItem.bind(this)}/>
          )
        }
      }
    ]

    let {applyLoading} = this.props;

    return (
      <WizSpin tip="文件上传中" spinning={applyLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
          other={other}
        />
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {apply} = state
  const applyStudentImport = modelUtils.getModelEntity(apply, 'importApplyStudent')
  const load = modelUtils.getLoadingState(state, 'apply')
  return {
    applyStudentImport,
    ...load
  }
}

export default connect(mapStateToProps)(ApplyStudentImport)
